
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_105_323)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.28 18.177v3.234c0 1.43-1.318 2.589-2.942 2.589H2.942C1.317 24 0 22.84 0 21.411V11.383c0-1.43 1.318-2.589 2.942-2.589h3.676v7.116c0 1.252 1.154 2.267 2.575 2.267h8.086zM7.72 7.824V4.589C7.72 3.159 9.039 2 10.663 2h11.396C23.683 2 25 3.16 25 4.589v10.028c0 1.43-1.318 2.589-2.942 2.589h-3.676V10.09c0-1.252-1.154-2.266-2.575-2.266H7.72zm9.56 9.382H9.191c-.812 0-1.471-.58-1.471-1.295V8.794h8.087c.812 0 1.471.58 1.471 1.295v7.117zM9.19 10.088v4.53c0 .714.66 1.294 1.471 1.294h5.147v-5.174c0-.358-.33-.65-.738-.65H9.19z","fill":"#282828"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_105_323"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    